import { useEffect, useState } from 'react';
import { api } from '@/utils/api';

export function AuditPhoto({ url }: { url: string }) {
  const [source, setSource] = useState('');
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let active = true; let objectUrl = '';
    setFailed(false); setSource('');
    if (!/^\/safety-audits\/\d+\/photos\/\d+$/.test(url)) { setFailed(true); return () => {}; }
    api.get(url, { responseType: 'blob' }).then(res => {
      if (!active) return;
      objectUrl = URL.createObjectURL(res.data); setSource(objectUrl);
    }).catch(() => { if (active) setFailed(true); });
    return () => { active = false; if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [url]);
  return failed ? <span role="alert">Photo could not be loaded</span> : source ? <a href={source} target="_blank" rel="noreferrer"><img src={source} alt="Audit photo evidence" className="max-h-48 max-w-full rounded border" /></a> : <span>Loading photo…</span>;
}
